module.exports = __webpack_public_path__ + "assets/img/help_pagination04-1.d2e68759.svg";